module.exports = __webpack_public_path__ + "img/competencies.eb50b038.svg";